<div class="conn-card conn-grid-settings">
    <div *ngFor="let opt of options">
        <div class="conn-card-settings" (click)="optionClicked(opt.id)">
            <i [class]="opt.icon" style="font-size: 3rem; color: var(--primary-color)"></i>
            <h5>{{opt.name}}</h5>
        </div>
    </div>
</div>
